import { TextField } from "@material-ui/core";
import { Event } from "@material-ui/icons";
import styled from "styled-components";

export default function RuleFour({value, onChange}) {

    function handleChange(e) {
        var value = Number(e.target.value);
        if (value > 31) {
            e.target.value = 31
        } else if (value < 0) {
            e.target.value = 0
        }
        onChange(e.target.value)
    }

    return (
        <RuleContainer>
            <RuleDescription>
                <Event style={{ fontSize: '16px', marginRight: '6px', color: '#667eea' }} />
                Vencimento entre o dia 01 e 31
            </RuleDescription>
            <StyledTextField>
                <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="Dia do mês"
                    type="number"
                    min='0'
                    max='31'
                    placeholder="Ex: 15"
                    value={value}
                    onChange={handleChange}
                    autoComplete="off"
                    variant="outlined"
                />
            </StyledTextField>
        </RuleContainer>
    )
}

const RuleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const RuleDescription = styled.p`
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
    display: flex;
    align-items: center;
    font-family: 'Mulish', sans-serif;
`;

const StyledTextField = styled.div`
    .MuiOutlinedInput-root {
        border-radius: 10px;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
        }

        &.Mui-focused {
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        }
    }

    .MuiOutlinedInput-input {
        font-family: 'Mulish', sans-serif;
        font-size: 14px;
    }

    .MuiInputLabel-outlined {
        font-family: 'Mulish', sans-serif;
    }
`;